import { APP_NAME } from 'src/js/constants/common';
import getSiteIdRecreate from 'src/js/modules/sites/accessors/get-site-id-recreate';
import track from '../helpers/track';
import eventTypes from '../constants/event-types';

const trackSiteSetupSiteNameProvided = ({ siteName, archetypeId, businessCategory = null }) =>
  track(eventTypes.SITESETUP_SITE_NAME_PROVIDED, {
    appName: APP_NAME,
    siteId: getSiteIdRecreate() || null,
    siteName,
    archetypeId,
    businessCategory,
  });

export default trackSiteSetupSiteNameProvided;
